// Import CSS

import React, { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNav = useCallback(() => {
    setIsOpen(!isOpen);
    document.body.classList.toggle("hidden-scrolling");
  }, [isOpen]);

  const collapseSubMenu = () => {
    const activeSubMenu = document.querySelector(
      ".menu-item-has-children.active .sub-menu"
    );
    activeSubMenu.removeAttribute("style");
    activeSubMenu.parentElement.classList.remove("active");
  };

  const resizeFix = useCallback(() => {
    if (isOpen) {
      toggleNav();
    }
    if (document.querySelector(".menu-item-has-children.active")) {
      collapseSubMenu();
    }
  }, [isOpen, toggleNav]);

  useEffect(() => {
    const mediaSize = 991;

    const handleToggleNav = () => {
      const navMenu = document.querySelector(".nav-menu");
      const menuOverlay = document.querySelector(".menu-overlay");
      navMenu.classList.toggle("open");
      menuOverlay.classList.toggle("active");
      toggleNav();
    };

    const handleMenuClick = (event) => {
      if (
        event.target.hasAttribute("data-toggle") &&
        window.innerWidth <= mediaSize
      ) {
        event.preventDefault();
        const menuItemHasChildren = event.target.parentElement;
        if (menuItemHasChildren.classList.contains("active")) {
          collapseSubMenu();
        } else {
          if (document.querySelector(".menu-item-has-children.active")) {
            collapseSubMenu();
          }
          menuItemHasChildren.classList.add("active");
          const subMenu = menuItemHasChildren.querySelector(".sub-menu");
          subMenu.style.maxHeight = subMenu.scrollHeight + "px";
        }
      }
    };

    const handleResize = () => {
      if (window.innerWidth > mediaSize) {
        resizeFix();
      }
    };

    document
      .querySelector(".open-nav-menu")
      .addEventListener("click", handleToggleNav);
    document
      .querySelector(".close-nav-menu")
      .addEventListener("click", handleToggleNav);
    document
      .querySelector(".menu-overlay")
      .addEventListener("click", handleToggleNav);
    document
      .querySelector(".nav-menu")
      .addEventListener("click", handleMenuClick);
    window.addEventListener("resize", handleResize);

    return () => {
      document
        .querySelector(".open-nav-menu")
        .removeEventListener("click", handleToggleNav);
      document
        .querySelector(".close-nav-menu")
        .removeEventListener("click", handleToggleNav);
      document
        .querySelector(".menu-overlay")
        .removeEventListener("click", handleToggleNav);
      document
        .querySelector(".nav-menu")
        .removeEventListener("click", handleMenuClick);
      window.removeEventListener("resize", handleResize);
    };
  }, [isOpen, resizeFix, toggleNav]);

  return (
    <header className="header">
      <div className="header-main">
        <div className="logo">
          <img src="./assets/logo/iif.WebP" alt="" />
        </div>
        <div className="open-nav-menu">
          <span></span>
        </div>
        <div className="menu-overlay"></div>
        <nav className="nav-menu ">
          <div className="close-nav-menu">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <ul className="menu">
            <li className="menu-item mt-0">
              <a href="/">Utama</a>
            </li>
            <li className="menu-item">
              <a href="/#about">Tetang</a>
            </li>
            <li className="menu-item menu-item-has-children">
              <a href="#!" data-toggle="sub-menu">
                Buku Panduan
              </a>
              <ul className="sub-menu text-center">
                <li className="menu-item">
                  <a
                    href="https://drive.google.com/file/d/1Z97vyjwo_lhVNde2lD2UQ6RtP602iU4P/view?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    2026
                  </a>
                </li>
                <li className="menu-item">
                  <a
                    href="https://drive.google.com/file/d/1ngKTN5tb0D2prrMjTAG_SjeDUoi5dikM/view?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    2025
                  </a>
                </li>
                <li className="menu-item">
                  <a
                    href="https://drive.google.com/file/d/167kKqLfQrdOMEngkM9j3nKnmGepEmAu-/view?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    2024
                  </a>
                </li>
              </ul>
            </li>
            <li className="menu-item menu-item-has-children">
              <a href="/lowtahun">Daftar Pemenang</a>
            </li>
            <li className="menu-item menu-item-has-children">
              <a href="#!" data-toggle="sub-menu">
                Kurasi
              </a>
              <ul className="sub-menu text-center">
                <li className="menu-item">
                  <a
                    href="https://drive.google.com/drive/folders/12O5SHv24t-i4LqjGqZQDu85AqOIvQLRF?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Kurasi 2026
                  </a>
                </li>
                <li className="menu-item">
                  <a
                    href="https://drive.google.com/drive/u/0/folders/1SyFTOmgLJHpYxHnnsSFntJhZdMTWqoN4?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Kurasi 2025
                  </a>
                </li>
                <li className="menu-item">
                  <a
                    href="https://drive.google.com/drive/folders/1K2ZmLBiRhm2NByXjy3WikeARYimR0DY_?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Kurasi 2024
                  </a>
                </li>
                <li className="menu-item">
                  <a
                    href="https://drive.google.com/drive/folders/1OV_ezBzC8nIE5iWQ_h96jwmQN2Otl66s?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Kurasi 2023
                  </a>
                </li>
              </ul>
            </li>
            <li className="menu-item menu-item-has-children">
              <a href="#!" data-toggle="sub-menu">
                Liputan Media
              </a>
              <ul className="sub-menu text-center">
                <li className="menu-item">
                  <a
                    href="https://drive.google.com/file/d/1ZAgzQhkA9uWHExyAmNsUbS9wzXYW6yLu/view?usp=drive_link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Press Release 2026
                  </a>
                  <a
                    href="https://docs.google.com/document/d/1ezesJ_6t1-_r-XvQBY1dhonXeDEK2qK6Oyqfyc0OBng/edit?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Press Release 2025
                  </a>
                </li>
                <li className="menu-item">
                  <a
                    href="https://drive.google.com/file/d/11i9_zuCRNPiDdsVmQM_--YbQEOgRvlKl/view?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Press Release 2024
                  </a>
                </li>
              </ul>
            </li>
            <li className="menu-item menu-item-has-children">
              <a href="#!" data-toggle="sub-menu">
                Gallery
              </a>
              <ul className="sub-menu text-center">
                <li className="menu-item">
                  <a
                    href="https://drive.google.com/drive/folders/1BNjr7vXRFy2z1YZtMxRTo1sp8V6pJirH?usp=sharing"
                    rel="noreferrer"
                    target="_blank"
                  >
                    2026
                  </a>
                </li>
                <li className="menu-item">
                  <a
                    href="https://drive.google.com/drive/folders/1tWerDv4ZyIWdBsumxA3pdcYArdOobaKY?usp=sharing"
                    rel="noreferrer"
                    target="_blank"
                  >
                    2025
                  </a>
                </li>
              </ul>
            </li>
            <li className="menu-item">
              <a
                href="https://drive.google.com/drive/folders/1giEmcoKdIdgMKRkxLcO6dvvW9G817jQb?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                Sertifikat Supervisor
              </a>
            </li>
            <li className="menu-item">
              <a href="/faq">FAQ</a>
            </li>
            <li className="menu-item">
              <a href="/#contact">Kontak</a>
            </li>
          </ul>
        </nav>
      </div>
      {/* </div> */}
    </header>
  );
};
export default Header;
